module.exports = "../../../../platform/assets/pageMainIcon/icon-zhuangtai-3-green.svg";